import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';

const icons = {
    AssignmentTurnedInIcon
};

const assignBillingFin = {
    id: 'assign_billing_finance',
    type: 'group',
    children: [
        {
            id: 'assign_billing_finance_1',
            title: 'Assign Billing Type',
            type: 'item',
            url: '/Assign_Billing_Type',
            icon: icons.AssignmentTurnedInIcon,
        }
    ]
};

export default assignBillingFin;